import { ContactPreferenceOptions } from "@seneca/notifications-service-types";

import useGetTeacherPreferencesOptions from "features/teachers/pages/settings/components/tabs/TeacherNotificationsPreferencesPage/hooks/useGetPreferencesOptions";
import useGetParentPreferencesOptions from "features/parents/pages/settings/components/ParentNotificationsPreferencesPage/hooks/useGetPreferencesOptions";

const commonUserPreferencesOptions: {
  name: keyof ContactPreferenceOptions;
  description: string;
}[] = [
  {
    name: "schoolTeacherParentInvite",
    description: "When a teacher invites you to view your child's progress"
  },
  {
    name: "studentParentInvite",
    description: "When your child wants to share their progress with you"
  },
  {
    name: "studentParentInviteSharePremium",
    description: "When your child wants to share premium information with you"
  },
  {
    name: "teacherSignup",
    description: "When you sign up to Seneca as a teacher"
  },
  {
    name: "subscribed",
    description: "Unsubscribe from all notifications"
  }
];

export function useGetPreferencesOptions(
  contactType: keyof ContactPreferenceOptions | undefined
) {
  const teacherPreferencesOptions = useGetTeacherPreferencesOptions();
  const parentPreferencesOptions = useGetParentPreferencesOptions();

  if (teacherPreferencesOptions.some(option => option.name === contactType)) {
    return teacherPreferencesOptions;
  }

  if (parentPreferencesOptions.some(option => option.name === contactType)) {
    return parentPreferencesOptions;
  }

  if (
    commonUserPreferencesOptions.some(option => option.name === contactType)
  ) {
    // We only want 1 subscribed option so need to remove from teacher + parent options
    return [
      ...teacherPreferencesOptions.filter(
        option => option.name !== "subscribed"
      ),
      ...parentPreferencesOptions.filter(
        option => option.name !== "subscribed"
      ),
      ...commonUserPreferencesOptions
    ].filter(option => option.name !== "subscribed");
  }

  return [];
}
